let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fUYfP")).then(() => parcelRequire('jfdC8'));